import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseApiService } from './base-api.service';
import { GetTagsResponseDto, SaveTagDto, TagsDto } from '../../dto';
import { map } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class TagsApiService {
    private readonly url: string = 'service/contactcloud/tags';

    constructor(
        private readonly baseApiService: BaseApiService,
    ) { }

    getTagsList(): Observable<TagsDto[]> {
        return this.baseApiService.get<GetTagsResponseDto>(`${this.url}`, { showError: true }).pipe(map(res => res.tags));
    }

    createTag(tagObj: SaveTagDto): Observable<TagsDto> {
        return this.baseApiService.post<TagsDto>(`${this.url}`, tagObj, { showError: true });
    }
    
    updateTag(tagObj: SaveTagDto, tagId: number): Observable<null> {
        return this.baseApiService.put<null>(`${this.url}/${tagId}`, tagObj, { showError: true });
    }
    
    deleteTag(tagId: number): Observable<null> {
        return this.baseApiService.delete<null>(`${this.url}/${tagId}`, { showError: true });
    }
}